export default __webpack_public_path__ + "static/media/premium-thumbnail-pmw.0dd2c9eb.svg";